export default __webpack_public_path__ + "static/media/MtRanier.d1b3c490.jpg";